import React from 'react';
import { CustomDialog } from '../Components/CustomDialog';
import { dialogConfigs } from '../Utils/PMHelper';
import { TIndustry } from '../Types/domain.types';

interface CreateDomainDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (data: any) => void;
    isLoading?: boolean;
    editData?: TIndustry | null;
    mode?: 'create' | 'edit';
}

export const CreateDomainDialog = ({ 
    isOpen, 
    onClose, 
    onSave, 
    isLoading = false,
    editData = null,
    mode = 'create'
}: CreateDomainDialogProps) => {
    
    const getFields = () => {
        const baseFields = [...dialogConfigs.createDomain.fields];
        
        if (mode === 'edit' && editData) {
            return baseFields.map(field => {
                switch (field.name) {
                    case 'domainName':
                        return { ...field, defaultValue: editData.name };
                    case 'description':
                        return { ...field, defaultValue: editData.description || '' };
                    default:
                        return field;
                }
            });
        }
        
        return baseFields;
    };

    return (
        <CustomDialog
            isOpen={isOpen}
            onClose={onClose}
            title={mode === 'edit' ? 'Edit Domain' : dialogConfigs.createDomain.title}
            fields={getFields()}
            onSave={onSave}
            saveButtonText={mode === 'edit' ? 'Update' : 'Create'}
            isLoading={isLoading}
        />
    );
};